import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const Button = styled(MuiButton)(({ theme }) => ({
  marginTop: theme.spacing(1),
  float: 'right',
}));
